import React, { useState } from 'react'

import { Loader } from '../balises/common'
import { InputSearch, SearchResult } from '../balises/search'
import useFetch from '../hook/UseFetch'

const Search = ({ hearing }) => {
    const { data, loading, api } = useFetch()
    const [value, setValue] = useState('')

    return (
        <>
            <InputSearch hearing={hearing} value={value} api={api} setValue={setValue} />
            {loading ? (
                <div className="baseocom-h-96 baseocom-mt-20 baseocom-flex-row-center">
                    <Loader />
                </div>
            ) : data ? (
                <SearchResult data={data} value={value} />
            ) : null}
        </>
    )
}

export default Search
